import { investorTypeByID, investorTypeCreate, investorTypeDestroy, investorTypeList, investorTypeUpdate } from '@/services/ventures/investor-types.service'

export default {
	namespaced: true,
	state: {
		investorTypeList: { meta: { pagination: { total: 0 } } },
		investorType: {},
		investorTypeStatus: 'pending',
		investorTypeSaveStatus: 'init',
		investorTypeDeleteStatus: 'init',
	},
	getters: {
		getInvestorTypeList: s => s.investorTypeList,
		getInvestorType: s => s.investorType,
		getInvestorTypeStatus: s => s.investorTypeStatus,
		getInvestorTypeSaveStatus: s => s.investorTypeSaveStatus,
		getInvestorTypeDeleteStatus: s => s.investorTypeDeleteStatus,
	},
	mutations: {
		INVESTOR_TYPE_LIST(state, value) { state.investorTypeList = value },
		SET_INVESTOR_TYPE(state, value) { state.investorType = value },
		INVESTOR_TYPE_STATUS(state, value) { state.investorTypeStatus = value },
		INVESTOR_TYPE_SAVE_STATUS(state, value) { state.investorTypeSaveStatus = value },
		INVESTOR_TYPE_DELETE_STATUS(state, value) { state.investorTypeDeleteStatus = value },
	},
	actions: {
		async fetchInvestorTypeList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('INVESTOR_TYPE_STATUS', 'pending')
			commit('INVESTOR_TYPE_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await investorTypeList(params)
				commit('INVESTOR_TYPE_STATUS', 'init')
				commit('INVESTOR_TYPE_LIST', data)
				return data
			} catch (error) {
				commit('INVESTOR_TYPE_STATUS', 'init')
				throw error
			}
		},
		async saveInvestorType({ commit }, params) {
			commit('INVESTOR_TYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await investorTypeCreate(params)
				commit('INVESTOR_TYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTOR_TYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateInvestorType({ commit }, params) {
			commit('INVESTOR_TYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await investorTypeUpdate(params)
				commit('INVESTOR_TYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTOR_TYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteInvestorTypeByID({ commit }, params) {
			commit('INVESTOR_TYPE_DELETE_STATUS', 'pending')
			try {
				const { data } = await investorTypeDestroy(params)
				commit('INVESTOR_TYPE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('INVESTOR_TYPE_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
